import React, { useEffect, useState } from "react";
import { Button, Modal, Input, Select, DatePicker, Checkbox, Form } from 'antd';
import type { SelectProps } from 'antd';
import moment from "moment";
import "./CreateModel.less";
import { pricingApi, useSavePricingPlanV2Mutation } from 'services/pricingService';
import Notification from "common/components/NotificationMessage/Notification";

export default function
    ({ open, handleOk, handleCancel, handleData }) {

    const [accessType, setAccessType] = useState<string>('');
    const [pricingPlanName, setPricingPlanName] = useState<string>('');
    const [pricingPlanOldName, setPricingPlanOldName] = useState<string>('');
    const [pricingPlanType, setPricingPlanType] = useState<string>('');
    const [priorityType, setPriorityType] = useState<number>(0);
    const [serviceFee, setServiceFee] = useState<number>(0);
    const [pricingSchedules, setPricingSchedules] = useState<any[]>([]);
    const [defaultIdleRate, setDefaultIdleRate] = useState<number>(0);
    const [defaultRate, setDefaultRate] = useState<number>(0);
    const [unit, setUnit] = useState<string>('');
    const [authorizedAmount, setAuthorizedAmount] = useState<number>(0);
    const [maxChargeCutoffTime, setMaxChargeCutoffTime] = useState<string>('');
    const [managementFee, setManagementFee] = useState<number>(0);
    const [parkingFeeUnit, setParkingFeeUnit] = useState<string>('');
    const [rate, setRate] = useState<number>(0);
    const [type, setType] = useState<string>('');
    const [minimumCharge, setMinimumCharge] = useState<number>(0);
    const [maxChargePerDay, setMaxChargePerDay] = useState<number>(0);

    useEffect(() => {
        if (handleData) {
            handleData['accessType'] && setAccessType(handleData['accessType'])
            handleData['pricingPlanName'] && setPricingPlanName(handleData['pricingPlanName'])
            handleData['pricingPlanType'] && setPricingPlanType(handleData['pricingPlanType'])
            handleData['priorityType'] && setPriorityType(handleData['priorityType'])
            handleData['serviceFee'] && setServiceFee(handleData['serviceFee'])
            handleData['pricingSchedules'] && setPricingSchedules(handleData['pricingSchedules'])
            handleData['defaultIdleRate'] && setDefaultIdleRate(handleData['defaultIdleRate'])
            handleData['defaultRate'] && setDefaultRate(handleData['defaultRate'])
            handleData['unit'] && setUnit(handleData['unit'])
            handleData['authorizedAmount'] && setAuthorizedAmount(handleData['authorizedAmount'])
            handleData['maxChargeCutoff'] && setMaxChargeCutoffTime(handleData['maxChargeCutoff'])
            handleData['managementFee'] && setManagementFee(handleData['managementFee'])
            if (handleData['parkingFee']) {
                handleData['parkingFee']['unit'] && setParkingFeeUnit(handleData['parkingFee']['unit'])
                handleData['parkingFee']['rate'] && setRate(handleData['parkingFee']['rate'])
                handleData['parkingFee']['type'] && setType(handleData['parkingFee']['type'])
            }
            handleData['minimumCharge'] && setMinimumCharge(handleData['minimumCharge'])
            handleData['maxChargePerDay'] && setMaxChargePerDay(handleData['maxChargePerDay'])
        }
    }, [handleData])

    const handleChangeAccessType = (e) => {
        setAccessType(e)
    }

    const handleChangePlanType = (e) => {
        setPricingPlanType(e)
    }

    const handleChangeParkingFeeUnit = (e) => {
        setParkingFeeUnit(e)
    }

    const handleChangeParkingFeeType = (e) => {
        setType(e)
    }

    const cancelTap = () => {
        handleCancel()
    }

    const [savePricingPlan, { isSuccess: savePricingPlanSuccess, data: savePricingPlanData }] = useSavePricingPlanV2Mutation();



    useEffect(() => {
        if (savePricingPlanSuccess) {
            Notification({
                type: savePricingPlanData?.success ? "success" : "warning",
                message: savePricingPlanData?.success ? "save update pricing plan success" : "save update pricing plan failed",
                description: "",
            });
            handleCancel();
        }

    }, [savePricingPlanSuccess]);

    const saveTap = () => {
        savePricingPlan({
            accessType,
            pricingPlanOldName,
            pricingPlanNewName: pricingPlanName,
            pricingPlanType,
            priorityType,
            serviceFee,
            pricingSchedules,
            defaultIdleRate,
            defaultRate,
            unit,
            authorizedAmount,
            maxChargeCutoffTime,
            managementFee,
            parkingFee: {
                unit: parkingFeeUnit,
                rate,
                type
            },
            minimumCharge,
            maxChargePerDay,
        });
    }

    const handleChangeUnit = (e) => {
        setUnit(e)
    }

    const handleChangePriority = (e) => {
        setPriorityType(e)
    }

    // 自定义日期不可用的函数
    const disabledDate = (current) => {
        // 只允许选择当前日期之后的日期
        return current && current <= currentDate.startOf('minute');
    };

    const currentDate = moment();

    const options: SelectProps['options'] = [];
    const dayType = [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
    ]
    for (let i = 0; i < dayType.length; i++) {
        options.push({
            label: dayType[i],
            value: dayType[i],
        });
    }

    const handleChangeSchedules = (value: string[]) => {
        const list = value.map((item) => {
            return {
                dayType: item
            }
        })
        setPricingSchedules(list)
    };
    const optionsParking: SelectProps['options'] = [];
    const Parking = [
        "h", "day", "week", "month", "quarter", "year"
    ]
    for (let i = 0; i < Parking.length; i++) {
        optionsParking.push({
            label: Parking[i],
            value: Parking[i],
        });
    }
    const handleChangeParking = (value: string[]) => {
    };

    return (
        <Modal
            visible={open}
            title="Pricing Plan Detail"
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
            width={750}
        >
            <div className='model-content-pri'>
                <Form
                    initialValues={{ remember: true }}
                    onFinish={saveTap}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <div className="model-content-left">
                        <div className='model-content-item2'>
                            <p>Access Type: </p>
                            <Form.Item
                                label=""
                                name="accessType"
                            >
                                <div>{accessType}</div>
                            </Form.Item>

                        </div>
                        <div className='model-content-item2'>
                            <p>Pricing Plan Name: </p>
                            <Form.Item
                                label=""
                                name="pricingPlanName"
                            >
                                <div>{pricingPlanName}</div>
                            </Form.Item>

                        </div>
                        <div className='model-content-item2'>
                            <p>Pricing Plan Type: </p>
                            <Form.Item
                                label=""
                                name="pricingPlanType"
                            >
                                <div>{pricingPlanType}</div>
                            </Form.Item>

                        </div>
                        <div className='model-content-item2'>
                            <p>Priority Type: </p>
                            <Form.Item
                                label=""
                                name="priorityType"
                            >
                                <div>{priorityType}</div>
                            </Form.Item>
                        </div>
                        <div className='model-content-item2'>
                            <p>Service Fee: </p>
                            <div>{serviceFee}</div>
                        </div>
                        <div className='model-content-item2' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <p>Pricing Schedules: </p>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {pricingSchedules.map((item) => {
                                    return (
                                        <div style={{marginTop: '5px'}}>
                                            <div>dayType: {item.dayType}</div>
                                            <div>hourRange: {item.hourRange}</div>
                                            <div>rate: {item.rate}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='model-content-item2'>
                            <p>Default IdleRate: </p>
                            <div>{defaultIdleRate}</div>
                        </div>

                    </div>
                    <div className="model-content-right">

                        <div className='model-content-item2'>
                            <p>Default Rate: </p>
                            <div>{defaultRate}</div>
                        </div>
                        <div className='model-content-item2'>
                            <p>unit: </p>
                            <div>{unit}</div>
                        </div>

                        <div className='model-content-item2'>
                            <p>Authorized Amount: </p>
                            <div>{authorizedAmount}</div>
                        </div>
                        <div className='model-content-item2'>
                            <p>MaxCharge CutoffTime: </p>
                            <div>{maxChargeCutoffTime}</div>
                        </div>
                        <div className='model-content-item2'>
                            <p>Management Fee: </p>
                            <div>{managementFee}</div>
                        </div>
                        <div className='model-content-item-end'>
                            <p>Parking Fee: </p>
                            <div className="item-end-content">
                                <span>unit: </span>
                                <span>{parkingFeeUnit}</span>
                            </div>
                            <div className="item-end-content">
                                <span>rate: </span>
                                <span>{rate}</span>
                            </div>
                            <div className="item-end-content">
                                <span>type: </span>
                                <span>{type}</span>
                            </div>
                        </div>
                        <div className='model-content-item2'>
                            <p>Minimum Charge: </p>
                            <div>{minimumCharge}</div>
                        </div>
                        <div className='model-content-item2'>
                            <p>MaxCharge PerDay: </p>
                            <div>{maxChargePerDay}</div>
                        </div>
                    </div>
                </Form>

            </div>
        </Modal>
    )
}
